const SYSTEM_TITLE = '研和智能客户数据管理系统'   //登录时系统标题
const WELCOM_HEADER = '欢迎使用研和智能管理系统'
export default {
  SYSTEM_TITLE,
  WELCOM_HEADER
}

